import { render, staticRenderFns } from "./SidebarCategories.vue?vue&type=template&id=34829c06&scoped=true&"
import script from "./SidebarCategories.vue?vue&type=script&lang=js&"
export * from "./SidebarCategories.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCategories.vue?vue&type=style&index=0&id=34829c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34829c06",
  null
  
)

export default component.exports